import { z } from 'zod';

const refundErrorCodeSchema = z.union([
  z.literal(2).describe('Gift card is older than 14 days and cannot be refunded'),
  z.literal(3).describe('Gift card has been used'),
  z.literal(4).describe('Another gift card in the same order has already been used'),
]);

export const refundErrorSchema = z.object({
  errorCode: refundErrorCodeSchema,
});
